import { createAction } from '@reduxjs/toolkit'

export const setTotalElements = createAction<number>('setTotalElements')
export const setTotalPages = createAction<number>('setTotalPages')
export const clearLlistat = createAction('clearLlistat')
